__turbopack_context__.v({
  "component": "style-module-scss-module__HZ9o1G__component",
});
